import React from "react";
import { useSearchParams } from "react-router-dom";
import CoreNodeElement from "../CoreNodeDisplay";
import CoreNodeDisplaySpaces from "../CoreNodeDisplaySpaces";

const AgentView: React.FC = () => {
  const [searchParams] = useSearchParams();
  const spaceId = searchParams.get("spaceId");

  if (spaceId) {
    return <CoreNodeDisplaySpaces />;
  }

  return <CoreNodeElement />;
};

export default AgentView;
